
export default function (error) {
  return error.response ? error.response.data : error;
}
